module.exports = __webpack_public_path__ + "img/kv2.f5ab756.jpg";